import { render, staticRenderFns } from "./SafteElectronic.vue?vue&type=template&id=db2fdb30&scoped=true&"
import script from "./SafteElectronic.vue?vue&type=script&lang=js&"
export * from "./SafteElectronic.vue?vue&type=script&lang=js&"
import style0 from "./SafteElectronic.vue?vue&type=style&index=0&id=db2fdb30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2fdb30",
  null
  
)

export default component.exports